












import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseSpinner from "@/components/BaseSpinner";
import { getEmptyEarningReportTypeStats, getStatType } from "@/views/PageStatements/helpers";
import { EarningReportData, StatField } from "../../types";
import StatementChart from "../StatementChart";

export default defineComponent({
  name: "StatementChartController",
  components: { StatementChart, BaseSpinner },
  props: {
    report: { type: Object as () => EarningReportData, required: true },
    fields: { type: Array as () => StatField[], required: true },
  },
  setup(props) {
    const { authUserStrict } = useAuthUser();
    const reports = ref<EarningReportData[]>([]);
    const timeFrom = computed(() => {
      if (props.report.timeFrom) return props.report.timeFrom;
      return props.report.chartData[props.report.chartData.length - 1].timeFrom;
    });
    const timeTo = computed(() => {
      if (props.report.timeTo) return props.report.timeTo;
      return props.report.chartData[0].timeTo;
    });
    const computedChartData = computed<EarningReportData[] | null>(() => {
      if (props.report.chartData.length !== 0) return props.report.chartData;
      if (reports.value.length !== 0) return reports.value;
      return null;
    });

    const getReport = async () => {
      const response = await providers.TransactionProvider.getEarningReports({
        data: { userId: authUserStrict.value.id, dateFrom: timeFrom.value, dateTo: timeTo.value },
      });

      reports.value = response.map(item => {
        const typeStats = getEmptyEarningReportTypeStats(props.fields);

        item.details.forEach(stat => {
          const key = getStatType(stat, props.fields);
          typeStats[key].amount += stat.amount;
          typeStats[key].agentFee += stat.agentFee;
          typeStats[key].fee += stat.fee;
          typeStats[key].totalAmount += stat.totalAmount;
        });
        return {
          ...item,
          typeStats: typeStats,
          chartData: [],
        };
      });
    };

    if (props.report.chartData.length === 0) {
      getReport();
    }

    return { timeFrom, timeTo, computedChartData };
  },
});
